import { useMutation } from 'react-query';
import firebase from 'firebase/app';

import { REST_MNGT_ENDPOINT } from 'src/config';

const useMutateCheckRestInfo = () => {
  return useMutation(
    'cancel-remaining-lineup-as-shop-closed',
    async (user_uid) => {
      const idToken = await firebase.auth().currentUser?.getIdToken();
      const response = await fetch(
        `${REST_MNGT_ENDPOINT}/checkRestInfo?user_id=${user_uid}`,
        {
          headers: idToken ? { Authorization: `Bearer ${idToken}` } : {},
        }
      );

      if (!response.ok) {
        // throw new Error('Network response was not ok');
        console.error('error during cancelling the remaining lineup request');
      }

      return response.json();
    },
    { retry: 5 }
  );
};

export default useMutateCheckRestInfo;
